// @flow

import DataLayerEvent from './DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';

export default class FilterUse extends DataLayerEvent {
  /**
   * @inheritDoc
   */
  validate(): boolean {
    return this.data.filter && this.data.filter.name && this.data.filter.value;
  }

  /**
   * @inheritDoc
   */
  dispatch(): void {
    const data = {
      filter_name: this.data.filter.name,
      filter_value: this.data.filter.value
    };

    if (this.data.hasOwnProperty('checked')) {
      data.filter_checkbox = this.data.checked ? 'on' : 'off';
    }

    super.dispatch();
    this.push({
      event: EventNames.FILTER_USE,
      ecommerce: data
    });
  }
}
